export * from './url'
/* global Vue */
const Message = Vue.prototype.$message
/**
 * 给图片路径补全域名
 * @param {*} text
 */
export function imgAddHost (text) {
  let imgHost = window.fe.imgHost || '//public-img.sunyur.com'
  const isLinkRe = /^((http:\/\/)|(https:\/\/)|(\/\/))/
  if (isLinkRe.test(text)) {
    return text
  } else {
    if (text[0] === '/') {
      return imgHost + text
    } else {
      if (imgHost[imgHost.length - 1] === '/') {
        return imgHost + text
      } else {
        return imgHost + '/' + text
      }
    }
  }
}

/**
 * 日期区间选择可开区间时，辅助函数
 * 使用可参考：product/list/search-table.vue
 * @param refer, 参考的时间
 * @param action, 对比的操作，${date}相比${refer}满足此对比操作，则会disable
 * @param type, 参考时间的类型: timestamp/date
 * @param date, 传入的要比对的Date对象
 * @returns {boolean}
 */
export function disabledDate (refer, action, type = 'timestamp', date) {
  if (!refer) {
    return false
  }
  if (type === 'date') {
    refer = new Date(`${refer} 00:00:00`).getTime()
  }
  if (action === '>') {
    return date > refer
  } else if (action === '<') {
    return date < refer
  } else if (action === '>=') {
    return date >= refer
  } else if (action === '<=') {
    return date <= refer
  }
  return false
}

export function __merge (origin = {}, target = {}) {
  for (let p in origin) {
    if (target.hasOwnProperty(p)) {
      origin[p] = target[p]
    }
  }
  return origin
}

// 修改query
export function __changeQuery (target) {
  let v = window.vueInstantiation
  let currentQuery = v.$route.query
  // if (currentQuery.c) {
  let newQuery = JSON.parse(JSON.stringify(currentQuery))
  newQuery.c = JSON.stringify(target)
  v.$router.push({
    path: v.$route.path,
    query: newQuery
  })
  // }
}

// 将对象数组转成map - 基于某一prop
export function genMap (list, idPropName = 'id') {
  const map = {}
  list.forEach(node => {
    map[node[idPropName]] = node
  })
  return map
}

// 判断两个数组相同
export function arrayContentSame (arr1, arr2) {
  const set1 = new Set(arr1)
  const set2 = new Set(arr2)
  if (set1.size !== set2.size) return false

  for (let item of set2) {
    if (!set1.has(item)) return false
  }

  return true
}

// 判断端
export const projectInfo = {
  query () {
    return window.fe?.apaas?.biz?.project
  },
  include (str) {
    return this.query() === str
  }
}

/*
 * @description 防抖函数
 * @param {function} func 当前执行函数
 * @param {number} wait 等待时间
 * @param {boolean} immediate 是否立执行
 * @render {function} 包装后的函数
 * */
export function debounce (func, wait, immediate) {
  let timeout
  function debounceFunc (...args) {
    const context = this
    if (args[0] && args[0].persist) {
      args[0].persist()
    }
    const later = () => {
      timeout = null
      if (!immediate) {
        func.apply(context, args)
      }
    }
    const callNow = immediate && !timeout
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
    if (callNow) {
      func.apply(context, args)
    }
  }
  debounceFunc.cancel = function cancel () {
    if (timeout) {
      clearTimeout(timeout)
      timeout = null
    }
  }
  return debounceFunc
}

/**
 * @description 复制内容到剪切板
 * @param {String} content  要复制的内容
 * @param {Boolean} showSucceedTip 复制成功是否提示
 * @param {String} succeedContent 成功提示的内容
 */
export function copyToClipboard ({
  content = '',
  showSucceedTip = true,
  succeedContent = '复制成功！'
} = {}) {
  if (content) {
    var input = document.createElement('input')
    input.setAttribute('id', 'copyInput')
    input.setAttribute('value', content)
    document.getElementsByTagName('body')[0].appendChild(input)
    document.getElementById('copyInput').select()
    if (document.execCommand('copy')) {
      showSucceedTip && Message.success(succeedContent)
    } else {
      Message.error('复制失败！')
    }
    document.getElementById('copyInput').remove()
  } else {
    Message.error('复制内容为空！')
  }
}
